export default "__VITE_ASSET__DzyuGAqr__"